<template>
  <div id="facility">
    <template v-if="isMobile">
      <div>
        <div>시설 전경 (외부 전경)</div>
      </div>
      <div class="grid_wrap">
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/new_facility_1.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진1</div>
        </div>
        <div class="col-1 row-5">
          <div><img src="../../assets/intro/new_facility_3.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진3</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/new_facility_4.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진4</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/new_facility_5.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진5</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/new_facility_2.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진2</div>
        </div>
      </div>
      <div>
        <div>시설 현황 (내부 시설)</div>
      </div>
      <div class="grid_wrap">
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/facility_inside_1.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>회의실</div>
        </div>
        <div class="col-1 row-5">
          <div><img src="../../assets/intro/facility_inside_3.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>상담실</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/facility_inside_4.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>센터 전면</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/facility_inside_2.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>강의실 측면(빔)</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/facility_inside_5.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>심층상담실(1:1)</div>
        </div>
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>AI면접실</div>-->
<!--        </div>-->
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>동아리실(컴퓨터실)</div>-->
<!--        </div>-->
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>꿈둥지(구직자 카페)</div>-->
<!--        </div>-->
      </div>
    </template>
    <template v-else>
      <div>
        <div>시설현황</div>
        <div @click="showModal('mapPopup')">MAP 안내</div>
      </div>
      <div class="grid_wrap">
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/new_facility_1.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진1</div>
        </div>
        <div class="col-1 row-5">
          <div><img src="../../assets/intro/new_facility_3.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진3</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/new_facility_4.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진4</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/new_facility_5.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진5</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/new_facility_2.png"/></div>
          <div>구로구 중장년 일드림센터 외부 전경 사진</div>
          <div>외부 전경 사진2</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/facility_inside_1.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>회의실</div>
        </div>
        <div class="col-1 row-5">
          <div><img src="../../assets/intro/facility_inside_3.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>상담실</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/facility_inside_4.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>센터 전면</div>
        </div>
        <div class="col-1 row-3">
          <div><img src="../../assets/intro/facility_inside_2.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>강의실 측면(빔)</div>
        </div>
        <div class="col-1 row-2">
          <div><img src="../../assets/intro/facility_inside_5.png"/></div>
          <div>구로구 중장년 일드림센터 내부 사진</div>
          <div>심층상담실(1:1)</div>
        </div>
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>AI면접실</div>-->
<!--        </div>-->
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>동아리실(컴퓨터실)</div>-->
<!--        </div>-->
<!--        <div class="col-1 row-3">-->
<!--          <div><img src="../../assets/intro/facility_1.png"/></div>-->
<!--          <div>구로구 중장년 일드림센터 내부 사진</div>-->
<!--          <div>꿈둥지(구직자 카페)</div>-->
<!--        </div>-->
      </div>
    </template>
    <modal name="mapPopup" width="50%" height="auto">
      <div class="modal_wrap">
        <img src="../../assets/intro/facility_map.png" alt="시설 안내 지도"/>
      </div>
    </modal>
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  data () {
    return {
      isMobile: common.detectMobile()
    }
  },
  methods: {
    showModal (name) {
      this.$modal.show(name)
    }
  }
}
</script>

<style scoped>
#facility {
  display: flex;
  flex-direction: column;
  width: 1140px;
  margin: auto;
}

.mobile_wrap #facility {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

#facility > div:nth-child(1) {
  display: flex;
  margin-top: 55px;
}

.mobile_wrap #facility > div:nth-child(1),
.mobile_wrap #facility > div:nth-child(3) {
  display: flex;
  margin-top: 40px;
}

#facility > div:nth-child(1) > div:nth-child(1) {
  margin: auto auto auto 0;
  font-size: 38px;
  font-weight: 700;
}

.mobile_wrap #facility > div:nth-child(1) > div:nth-child(1),
.mobile_wrap #facility > div:nth-child(3) > div:nth-child(1) {
  margin: auto auto auto 0;
  font-size: 18px;
  font-weight: 700;
}

#facility > div:nth-child(1) > div:nth-child(2) {
  display: flex;
  width: 130px;
  height: 56px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  margin: auto 0 auto auto;
  background: #3E54EB;
  color: #FFFFFF;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

#facility > .grid_wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 70px;
}

.mobile_wrap #facility > .grid_wrap {
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 0;
}

.grid_wrap .col-1 {
  grid-column-end: span 1;
}

.grid_wrap .row-1 {
  grid-row-end: span 1;
}

.grid_wrap .col-2 {
  grid-column-end: span 2;
}

.grid_wrap .row-2 {
  grid-row-end: span 45;
}

.grid_wrap .col-3 {
  grid-column-end: span 3;
}

.grid_wrap .row-3 {
  grid-row-end: span 55;
}

.grid_wrap .row-4 {
  grid-row-end: span 4;
}

.grid_wrap .row-5 {
  grid-row-end: span 100;
}

.grid_wrap > div {
  display: flex;
  flex-direction: column;
  width: 360px;
  margin: 30px 30px 0 0;
}

.mobile_wrap .grid_wrap > div {
  width: 100%;
  margin: 16px 0 0;
}

.grid_wrap > div:nth-child(3),
.grid_wrap > div:nth-child(4),
.grid_wrap > div:nth-child(8),
.grid_wrap > div:nth-child(10),
.grid_wrap > div:nth-child(13) {
  margin-right: 0;
}

.grid_wrap > div > div:nth-child(1) {
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
}

.grid_wrap > div > div:nth-child(1) > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grid_wrap > div > div:nth-child(2) {
  flex-shrink: 0;
  padding-top: 19px;
  color: #292A34;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.286px;
  text-align: left;
}

.grid_wrap > div > div:nth-child(3) {
  flex-shrink: 0;
  padding-bottom: 19px;
  border-bottom: 1px solid #E7EBEF;
  color: #4F5059;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  text-align: left;
}

.modal_wrap {
  padding: 20px;
}

.modal_wrap > img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/intro/Facility.vue